
const PREFIX = 'ENQUIRY';

export class GET_ENQUIRY_DETAILS {
  static readonly type = `[${PREFIX}] GET ENQUIRY DETAILS`;

  constructor(public readonly payload: any) {}
}